var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
export default function BuyFreeMint(_a) {
    var count = _a.count;
    var t = useI18n().t;
    return (_jsx(Container, { children: _jsx("p", { children: _jsx(Trans, { components: {
                    gold: _jsx("span", { className: "gold" }),
                }, i18nKey: "mint.buy-free-mint.message", t: t, values: {
                    count: count,
                } }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n\n  & > p {\n    font-size: 16px;\n\n    .gold {\n      color: ", ";\n      font-weight: 700;\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n\n  & > p {\n    font-size: 16px;\n\n    .gold {\n      color: ", ";\n      font-weight: 700;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.gold;
});
var templateObject_1;
